interface BalanceBarProps {
  proPct: number
  isEmpty?: boolean
  className?: string
  proLabel?: string
  conLabel?: string
}

export function BalanceBar({
  proPct,
  isEmpty = false,
  className = '',
  proLabel = 'Pros',
  conLabel = 'Cons',
}: BalanceBarProps) {
  const accessibleProPct = isEmpty ? 0 : proPct
  const accessibleConPct = isEmpty ? 0 : 100 - proPct

  return (
    <div
      role="img"
      aria-label={`${proLabel} ${accessibleProPct}%, ${conLabel} ${accessibleConPct}%`}
      className={`w-full h-3.5 ${className}`}
      style={{
        backgroundColor: isEmpty ? 'var(--zine-bg2)' : 'var(--zine-con)',
      }}
    >
      <div
        className="h-full transition-all duration-500 border-r-[2.5px] border-black-500"
        style={{
          width: `${proPct}%`,
          backgroundColor: isEmpty ? 'var(--zine-bg2)' : 'var(--zine-pro)',
        }}
      />
    </div>
  )
}
